import * as React from 'react'
import { DataTypeProvider } from '@devexpress/dx-react-grid'
import { Link } from 'react-router-dom'
import { isFunction } from 'lodash'

const Formatter = ({ value, row, column }) => {
  // column.name === 'policy' && console.log(value, row, column)
  const { to } = column
  const label = isFunction(column.label)
    ? column.label(row) || ''
    : column.label
  return <Link to={`${to}/${value}`}>{label}</Link>
}

export default props => (
  <DataTypeProvider formatterComponent={Formatter} {...props} />
)
